export default "__VITE_ASSET__CuAYCOTz__"